import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/global-functions';
import { Solutions } from 'src/app/utils/solutions';
import { Router } from '@angular/router';


@Component({
    selector: 'app-dashboard-component',
    templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit { 
    constructor(private router: Router) {
     }

    ngOnInit(): void {
        this.load();
    }

    load() {
        var user = User.userInSession();

        var idSolution = user.IDSolucaoEntidade;

        if (idSolution == Solutions.ToolManegament) {
            this.router.navigate(['dashboardtm']);
        } else if (idSolution == Solutions.IndustrialVending) {
            this.router.navigate(['dashboardiv']);
        } else if (idSolution == Solutions.IndustrialVendingToolManagement) {
            this.router.navigate(['dashboardivtm']);
        } else {
            this.router.navigate(['dashboardiv']);
        }
    }
}
